import React from 'react'
import { Slider } from 'antd'
import { DeliveryCostConfigs } from 'Store/delivery-cost/types'
import styled from 'styled-components'
import { numberWithComma } from 'helpers/format'

type Props = {
  max: number
  item: DeliveryCostConfigs
  activeSlider?: boolean
  onUpdateDistanceData: (key: string, val: any) => void
}

const DistanceSlider: React.FunctionComponent<Props> = props => {
  const { item, activeSlider = false, onUpdateDistanceData, max } = props
  const unit = 'กม.'

  const onChangeSlideValue = (value: number[]) => {
    onUpdateDistanceData('end', value[1])
  }

  const renderMark = (startVal: number, endVal: number) => {
    const maskStyle = {
      fontSize: '12px',
      width: 'max-content',
    }
    return {
      // 0: {
      //   style: maskStyle,
      //   label: `0 กม.`,
      // },
      [startVal]: {
        style: maskStyle,
        label: `${formatter(startVal)}`,
      },
      [endVal]: {
        style: maskStyle,
        label: `${formatter(endVal)}`,
      },
      [max]: {
        style: maskStyle,
        label: `${formatter(max)}`,
      },
    }
  }

  const formatter = (value: any) => {
    return `${numberWithComma(value)} ${unit}`
  }

  const value = [item.start || 0, item.end] as [number, number]
  return (
    <SliderWrapper>
      <Slider
        tipFormatter={formatter}
        range={true}
        marks={renderMark(item.start || 0, item.end)}
        value={value}
        min={0}
        max={max}
        onChange={(val: number[]) => activeSlider && onChangeSlideValue(val)}
        step={1}
      />
    </SliderWrapper>
  )
}

const SliderWrapper = styled.div`
  padding: 0 10px;
`

export default DistanceSlider
